import '../../../../assets/css/setContract_forSubmission.css';
import React, { useState, useEffect } from 'react'
import { makeStyles } from '@mui/styles';
import { alpha } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import AppBar from '@mui/material/AppBar';
import Fab from '@mui/material/Fab';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import GetAppRoundedIcon from '@mui/icons-material/GetAppRounded';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Input from "@mui/material/Input";
import CloseIcon from '@mui/icons-material/Close';
import {
    get_contract_last_content, download_contractPDF, finalize_contract, contract_check, contract_is_being_edited,
    save_contract_content,save_contract_uploaded_content, sign_contract_generic, upload_contract, notify_supplier_with_simple_contract, add_contract_details
} from '../../../../services/purchase_service';
import Loading_animation_view from '../../../loading_animation_view/loading_animation_view';
import { get_contracts_types } from '../../../../services/for_allServices';


const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: 16,
        paddingRight: 8,
    },
    // highlight:
    //     theme.palette.mode === 'light'
    //         ? {
    //             color: theme.palette.secondary.main,
    //             backgroundColor: alpha(theme.palette.secondary.light, 0.85),
    //         }
    //         : {
    //             color: theme.palette.text.primary,
    //             backgroundColor: theme.palette.secondary.dark,
    //         },
    title: {
        flex: '1 1 100%',
    },
    input: {
        display: 'none',
    },
    select: {
        "&:focus": {
            backgroundColor: "white"
        }
    },
    selectInput: {
        "&:hover:not($disabled):not($focused):not($error):before": {
            borderBottomWidth: 0
        },
        "&:after": {
            borderBottomWidth: 0
        }
    },
    disabled: {},
    focused: {},
    error: {}
}));


function Upload_contract({ contract_details, close_contract_import, open }) {
    let purchase_service=JSON.parse(localStorage.getItem('user-info'))

    const classes = useToolbarStyles();
    const [contractMapping, setContractMapping] = useState({});
    const [selectedType, setSelectedType] = useState('');
    const [selectedSubtype, setSelectedSubtype] = useState('');
    const [subtypesForSelectedType, setSubtypesForSelectedType] = useState([]);
    const [uploadedPDF, setUploadedPDF] = useState(null);
    const [uploadedFile, setUploadedFile] = useState(null);


    //savepoint for contract form pdf

    useEffect(() => {
        get_contracts_types()
            .then((response) => {
                const mapping = response.data;
                setContractMapping(mapping);
            })
            .catch((error) => {
                console.error(error.response);
            });
    }, []);
    const handleTypeChange = (event) => {
        const type = event.target.value;
        setSelectedType(type);
        setSubtypesForSelectedType(contractMapping[type] || []);
        setSelectedSubtype(''); // reset subtype
    };

const save_contract = async () => {
   //  console.log("📝 Saving contract...");
   //  console.log("Type:", selectedType);
   //  console.log("Subtype ID:", selectedSubtype);
   //  console.log("Contract Details:", contract_details);
   //  console.log("Uploaded PDF:", uploadedFile);
   //  console.log("id_login:", purchase_service.id);

    if (!selectedType || !selectedSubtype || !uploadedFile || !contract_details) {
        console.warn("⚠️ Missing information: Please select type, subtype, and upload a PDF.");
        return;
    }

    try {
        // Create FormData for file upload
        const formData = new FormData();
        formData.append('contract', uploadedFile);
        formData.append('contract_id', selectedSubtype);
        formData.append('id_login', purchase_service.id);
        formData.append('contract_source', 'contract');
        formData.append('contract_details', JSON.stringify(contract_details));
        formData.append('version', '1'); // You can make this dynamic if needed

        // Call the API
        const response = await save_contract_uploaded_content(formData);
        
       //  console.log("✅ Contract saved successfully:", response.data);
        // You might want to add success notification here
        return response.data;
    } catch (error) {
        console.error("❌ Error saving contract:", error.response?.data || error.message);
        // You might want to add error notification here
        throw error;
    }
};



    return (
        <Dialog fullScreen open={open} onClose={close_contract_import} className="my_full_dialog contract_full_dialog">
            <AppBar className={classes.appBar}>
                <Toolbar className="contract_content_toolbar">
                    <div className="contract_content_toolbar_main_container">
                        <div className="contract_content_toolbar_left">
                            <div className='page_title'>
                                <IconButton edge="start" color="inherit" onClick={close_contract_import} aria-label="close" >
                                    <CloseIcon className="my_icon" />
                                </IconButton>

                            </div>
                            <FormControl variant='standard' className="header_form">
                                <InputLabel id="type-label">Type de contrat</InputLabel>
                                <Select
                                    labelId="type-label"
                                    value={selectedType}
                                    onChange={handleTypeChange}
                                >
                                    {Object.keys(contractMapping).map((type, index) => (
                                        <MenuItem key={index} value={type}>
                                            {type}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl variant='standard' className="header_form" disabled={!selectedType}>
                                <InputLabel id="subtype-label">Sous-type</InputLabel>
                                <Select
                                    labelId="subtype-label"
                                    value={selectedSubtype}
                                    onChange={(e) => setSelectedSubtype(e.target.value)}
                                >
                                    {subtypesForSelectedType.map((sub) => (
                                        <MenuItem key={sub.id} value={sub.id}>
                                            {sub.contract_subtype}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            {/* <Button className={contract_signed ? "status_success" : "status_waiting"}>
                                {contract_signed ? "signé" : "En cours"}
                            </Button> */}
                        </div>
                        <div className="contract_content_toolbar_right">
                            <Tooltip title="Enregistrer le contrat" placement="bottom" >
                                <span style={{ marginLeft: '6px' }}>
                                    <Button autoFocus className="submit_but border_button" color="inherit" onClick={save_contract} >
                                        Enregistrer*
                                    </Button>
                                </span>
                            </Tooltip>
                            <Tooltip title="Signer le contrat" placement="bottom" >
                                <span style={{ marginLeft: '6px' }}>
                                    <Button autoFocus className="submit_but border_button" style={{ color: "rgb(83 236 151)", fontWeight: "600" }} >
                                        signer
                                    </Button>
                                </span>
                            </Tooltip>
                            <Tooltip title="Exporter PDF">
                                <span style={{ marginLeft: '8px' }}>
                                    <Fab size="small" color="warning" >
                                        <GetAppRoundedIcon />
                                    </Fab>
                                </span>
                            </Tooltip>
                            <Tooltip title="Importer PDF">
                                <label htmlFor="uploadContract" style={{ marginLeft: '6px' }}>
                                    <input
                                        accept="application/pdf"
                                        id="uploadContract"
                                        type="file"
                                        hidden
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file && file.type === "application/pdf") {
                                                const fileURL = URL.createObjectURL(file);
                                                setUploadedPDF(fileURL);
                                                setUploadedFile(file);
                                            }
                                        }}
                                    />
                                    <Fab variant="contained" color="warning" component="span" size="small">
                                        <CloudUploadIcon />
                                    </Fab>
                                </label>
                            </Tooltip>
                            <Tooltip title="Notifier fournisseur">
                                <span style={{ marginLeft: '8px' }}>
                                    <Fab size="small" color="warning" >
                                        <NavigateNextIcon />
                                    </Fab>
                                </span>
                            </Tooltip>
                        </div>
                    </div>
                </Toolbar>
            </AppBar>
            {uploadedPDF ? (
                <div className="text_editor_container" style={{ height: '100vh', overflow: 'hidden' }}>
                    <iframe
                        src={uploadedPDF}
                        width="100%"
                        height="100%"
                        style={{ border: "none" }}
                        title="PDF Viewer"
                    />
                </div>
            ) : (
                <div style={{ padding: '2rem', textAlign: 'center' }}>
                    <h3>Aucun fichier PDF importé</h3>
                </div>
            )}


            {/* {contract_form_pdf ? (
                <div className="text_editor_container">
                    <iframe src={contract_form_pdf} width="100%" height="100%" />
                </div>
            ) : (
                <Loading_animation_view />
            )} */}

            {/* <Backdrop open={waiting}>
                <CircularProgress color="inherit" />
            </Backdrop> */}
        </Dialog>
    );
}



export default Upload_contract;